import React, { useEffect } from 'react';
import { Box } from '@mui/material';
import {
  TOOLBAR_ITEMS_REGISTRY,
  DEFAULT_TOOLBAR_ITEMS,
  ToolbarItemType,
} from './toolbar-items/toolbarItemRegistry';
import { useRichTextEditor } from './RichTextEditorProvider';

interface RichTextToolbarProps {
  items?: ToolbarItemType[];
}

export const RichTextToolbar = ({ items = DEFAULT_TOOLBAR_ITEMS }: RichTextToolbarProps) => {
  const { setUrlEditorOpen } = useRichTextEditor();
  useEffect(() => {
    return () => {
      setUrlEditorOpen(false);
    };
  }, [setUrlEditorOpen]);
  return (
    <Box
      className="rich-text-toolbar"
      sx={{ display: 'flex', alignItems: 'center', justifyContent: 'center', gap: '4px' }}
    >
      {items.map((itemKey, index) => {
        const Component = TOOLBAR_ITEMS_REGISTRY[itemKey];
        if (!Component) {
          console.warn(`Toolbar item "${itemKey}" not found in registry`);
          return null;
        }
        // Use a combination of itemKey and index for key to allow multiple separators
        return <Component key={`${itemKey}-${index}`} />;
      })}
    </Box>
  );
};
